export interface GeneroOption {
  value: number;
  label: string;
}

export const GeneroOptions: GeneroOption[] = [
  {
    value: 1,
    label: 'Feminino',
  },
  {
    value: 2,
    label: 'Masculino',
  },
  {
    value: 3,
    label: 'Não desejo informar',
  },
];
